<template>
    <div class="m-2">
        <div class="card m-2 shadow">

            <!--cabezera-->
            <div class="card-header">

                <div class="d-flex">
                    <div class="flex-fill">
                        <StatementsSearch></StatementsSearch>
                    </div>

                    <div class="float-end">
                        <StatementsPagination></StatementsPagination>
                    </div>

                </div>

            </div>

            <!--cuerpo-->
            <div class="card-body">
                <StatementsTable></StatementsTable>
            </div>
        </div>
    </div>
</template>
<script>
import StatementsTable from '@/components/PepStatements/PepStatementsList/Pep-statements-table.vue'
import StatementsPagination from '@/components/PepStatements/PepStatementsList/Pep-statements-pagination.vue';
import StatementsSearch from '@/components/PepStatements/PepStatementsList/Pep-statements-search.vue';

export default {
    name: 'StatementsList',

    components:{
        StatementsTable,
        StatementsPagination,
        StatementsSearch
    }
}
</script>
<style></style>